"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_dropzone_1 = __importDefault(require("react-dropzone"));

var Button_1 = __importDefault(require("../Button"));

var uploader = function uploader(props) {
  var files = props.files,
      onDrop = props.onDrop,
      showFiles = props.showFiles,
      localization = props.localization,
      multiple = props.multiple;
  var button;

  if (localization.button) {
    button = react_1.default.createElement(Button_1.default, {
      type: "button"
    }, localization.button);
  }

  var fileList;

  if (showFiles) {
    fileList = react_1.default.createElement("div", {
      className: "file_list"
    }, react_1.default.createElement("ul", null, files.map(function (f) {
      return react_1.default.createElement("li", {
        key: f.name
      }, f.name, " - ", f.size, " bytes");
    })));
  }

  return react_1.default.createElement("div", {
    className: "emankit__uploader"
  }, fileList, react_1.default.createElement(react_dropzone_1.default, {
    onDrop: onDrop,
    multiple: multiple
  }, function (_a) {
    var getRootProps = _a.getRootProps,
        getInputProps = _a.getInputProps;
    return react_1.default.createElement("div", __assign({}, getRootProps(), {
      className: "dropzone"
    }), react_1.default.createElement("input", __assign({}, getInputProps())), react_1.default.createElement("p", {
      className: "text"
    }, localization.text), react_1.default.createElement("p", null, localization.or), button);
  }));
};

exports.default = uploader;